var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 359,
    viewBox: "0 0 364 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.344 79.9595C125.031 75.3921 130.405 73.2811 134.017 76.1597L293.259 203.069C296.871 205.948 296.012 211.657 291.713 213.346L102.186 287.799C97.8866 289.487 93.3716 285.889 94.0585 281.322L124.344 79.9595Z",
    fill: "#E67200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.516 57.6498C142.203 53.0824 147.577 50.9714 151.189 53.85L310.431 180.759C314.043 183.638 313.184 189.347 308.885 191.036L119.357 265.489C115.058 267.178 110.543 263.579 111.23 259.012L141.516 57.6498Z",
    fill: "#FF8B1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.43c673f4929e2c77f6b1b43dd02046db.svg";
export { ForwardRef as ReactComponent };